import React, { Component, type ErrorInfo, type ReactNode } from 'react'
import { IoRefreshOutline, IoWarningOutline } from 'react-icons/io5'

interface Props {
  children: ReactNode
  widgetId: string
  widgetTitle: string
  onRetry?: () => void
}

interface State {
  hasError: boolean
  error: Error | null
}

export class WidgetErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`Widget "${this.props.widgetId}" error:`, error, errorInfo)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
    this.props.onRetry?.()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="widget widget--error">
          <div className="widget-header">
            <div className="widget-header-left">
              <IoWarningOutline size={18} className="widget-icon widget-icon--error" />
              <h3 className="widget-title">{this.props.widgetTitle}</h3>
            </div>
          </div>
          <div className="widget-body">
            <div className="widget-error-boundary">
              <IoWarningOutline size={24} className="widget-error-icon" />
              <p className="widget-error-message">Something went wrong</p>
              <button className="widget-error-retry" onClick={this.handleRetry}>
                <IoRefreshOutline size={16} />
                Try again
              </button>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
